import { FaClock, FaTrophy, FaChartBar, FaTable } from "react-icons/fa";

// Etiketler PDF'te basılan bölümlerle birebir (#209 — rapor performans raporu
// tasarımına geçti; anahtarlar sunucu sözleşmesi gereği değişmedi):
//   hourlyDistribution → Saatlik dağılım, topDevices → Makine özeti,
//   peakHours → Yorumlar (içgörüler), deviceTable → Gün × makine tablosu.
// Ortalamalar her raporda basılır.
export const REPORT_SECTIONS = [
  { key: "hourlyDistribution", label: "Saatlik Dağılım", Icon: FaClock },
  { key: "topDevices", label: "Makine Özeti", Icon: FaTrophy },
  { key: "peakHours", label: "Yorumlar", Icon: FaChartBar },
  { key: "deviceTable", label: "Gün × Makine Tablosu", Icon: FaTable },
];

export const DEFAULT_SECTIONS_ALL_ON = {
  peakHours: true,
  hourlyDistribution: true,
  topDevices: true,
  deviceTable: true,
};

export function countActiveSections(sections) {
  if (!sections) return 4;
  return REPORT_SECTIONS.reduce(
    (acc, { key }) => acc + (sections[key] ? 1 : 0),
    0
  );
}

export function anySectionOn(sections) {
  if (!sections) return true;
  return REPORT_SECTIONS.some(({ key }) => !!sections[key]);
}
